export const CLINICAL_HUD5_TEACHING_PATH = "/clinical-hud-5";

export function clinicalHud5TeachingSessionPath(sessionId) {
  return `${CLINICAL_HUD5_TEACHING_PATH}/case/${sessionId}`;
}
